import { Dayjs } from 'dayjs';

import { format } from './format';

export const toISODate = (value: ParsableDate | Dayjs | null) => format(value, 'YYYY-MM-DD');
